<div class="area-header-container d-flex justify-content-between">
    <div class="d-flex justify-content-start">
        <div class="user-picture-container">
            <img
                alt="User picture"
                class="user-picture"
                [src]="profilePicture"
                [ngClass]="{ 'round': round }"
            />
            <div
                *ngIf="enablePictureUpload"
                class="camera-overlay"
                (click)="fileInput.click()"
                tabindex="0"
                (keyup)="onCameraOverlayKeyUp($event, fileInput)"
                title="Upload picture"
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 15.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4z" />
                    <path
                        d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z" />
                </svg>
            </div>
            <input
                #fileInput
                type="file"
                accept="image/*"
                (change)="onFileSelected($event)"
                hidden
            />
        </div>
        <div
            class="
                user-text-container
                d-flex
                flex-column
                justify-content-between
            "
        >
            <p class="name-info">
                {{ largeHeadline }}
            </p>
            <p class="other-info">
                <ng-container *ngIf="smallHeadlineRaw; else translated">
                    <img *ngIf="smallHeadlineIconPath" class="small-headline-icon"
                         [src]="smallHeadlineIconPath"
                         alt="small-headline-icon">
                    <span class="small-headline-text">{{ smallHeadlineRaw }}</span>
                </ng-container>
                <ng-template #translated>
                    {{ smallHeadlineTranslationKey | translate }}
                </ng-template>
            </p>
        </div>
    </div>
    <button
        *ngIf="buttonTextTranslationKey"
        class="common-button"
        (click)="onButtonClick()"
    >
        {{ buttonTextTranslationKey | translate }}
    </button>
</div>
